import config from '@/config'

const bgmList = [
  {
    title: 'Acoustic',
    url: `${config.cloudfrontPublic}/BGM/Acoustic.mp3`,
  },
  {
    title: 'Ambient',
    url: `${config.cloudfrontPublic}/BGM/Ambient.mp3`,
  },
  {
    title: 'Award',
    url: `${config.cloudfrontPublic}/BGM/Award.mp3`,
  },
  {
    title: 'Calm',
    url: `${config.cloudfrontPublic}/BGM/Calm.mp3`,
  },
  {
    title: 'Feel good',
    url: `${config.cloudfrontPublic}/BGM/Feel-good.mp3`,
  },
  {
    title: 'Funky',
    url: `${config.cloudfrontPublic}/BGM/Funky.mp3`,
  },
  {
    title: 'Inspiring',
    url: `${config.cloudfrontPublic}/BGM/Inspiring.mp3`,
  },
  {
    title: 'Lofi',
    url: `${config.cloudfrontPublic}/BGM/Lofi.mp3`,
  },
  {
    title: 'Lunar New Year',
    url: `${config.cloudfrontPublic}/BGM/Lunar-New-Year.mp3`,
  },
  {
    title: 'Rock',
    url: `${config.cloudfrontPublic}/BGM/Rock.mp3`,
  },
]
export default bgmList
